

export const createUrl = (baseUrl, obj, brackets = false) => {
	const base = new URL(baseUrl)
	base.search = ''
	for (const param in obj) {
		const val = obj[param]
		if (typeof val === 'string' && val.length || typeof val === 'number') {
			base.searchParams.append(param, val)
		}
		if (typeof val === 'boolean') {
			base.searchParams.append(param, val ? 'true' : 'false')
		}
		if (Array.isArray(val) && val.length) {
			val.map(val => base.searchParams.append(brackets ? param + '[]' : param, val))
		}
	}
	return base.toString().replaceAll('%5B%5D=', '[]=')
}


export const createModel = (data = {}) => {
	const get = key => data[key] ?? undefined
	const getAll = () => data
	const set = (key, value) => {
		data[key] = value
		return model
	}
	const remove = key => {
		delete data[key]
		return model
	}
	const addTo = (key, value) => {
		if (Array.isArray(data[key]) && !hasItem(key, value)) {
			data[key].push(value)
		}
		return model
	}
	const removeFrom = (key, value) => {
		if (Array.isArray(data[key])) {
			data[key].splice(data[key].indexOf(value), 1)
		}
		return model
	}
	const hasItem = (key, value) => {
		return Array.isArray(data[key]) && data[key].indexOf(value) > -1
	}
	const copy = () => createModel(structuredClone(data))

	const model = { get, getAll, set, remove, addTo, removeFrom, hasItem, copy }
	return model
}